<template>
  <div id="app" class="App">
    <FullViewLoading v-if="isWaitingForSaleServicePointData" />

    <TheHeader :language="paymentLanguage" :logoImage="logo || brandLogo" />
    <el-main role="main" class="App__main-view">
      <router-view></router-view>
    </el-main>
    <TheFooter v-if="!isWaitingForSaleServicePointData && shouldShowFooter" :colors="brandColors" />
    <AppVersion />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ManageTokenService from '@/services/ManageTokenService';
import TheHeader from '@/components/Common/TheHeader';
import TheFooter from '@/components/Common/TheFooter';
import FullViewLoading from '@/components/Common/FullViewLoading';
import AppVersion from '@/components/Common/AppVersion';
import { getFromLocalstorage } from '@/services/LocalstorageService';

export default {
  name: 'app',
  components: {
    TheHeader, TheFooter, FullViewLoading, AppVersion,
  },
  data() {
    return {
      logo: '',
    };
  },
  async created() {
    const logoFromLocalstorage = await getFromLocalstorage('logo');
    this.logo = this.brandLogo || logoFromLocalstorage;
  },
  computed: {
    ...mapGetters(['paymentLanguage', 'gatewayUrl', 'brandLogo', 'isWaitingForSaleServicePointData', 'brandColors']),
    shouldShowFooter() {
      // return ['pay'].includes(this.$route.name);
      return true;
    },
  },
  watch: {
    gatewayUrl(url) {
      if (url) {
        ManageTokenService.removeTokenFromStorage();
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .App
    width: 100%
    min-height: 100vh
    display: flex
    flex-direction: column
    justify-content: space-between
    position: relative
    &__main-view
      width: 100%
      margin: auto
      display: flex
      align-items: center
      max-width: 1280px
      padding: 135px 20px 30px 20px !important
      background: url('~/static/img/background.png') no-repeat scroll center bottom white
      background-size: cover
      @include breakpoint(xsmall)
        padding: 70px 20px 30px 20px !important
        overflow: hidden
</style>



// WEBPACK FOOTER //
// src/App.vue